(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

  if (document.body.classList.contains('template-index')) { document.querySelectorAll('[data-sano-price-motion]').forEach(function(price){price.dataset.priceAnimated='true';price.classList.add('is-price-animated');}); return; }
  var prices = document.querySelectorAll('[data-sano-price-motion]');
  prices = Array.prototype.filter.call(prices,function(price){return !(price.hasAttribute('data-sano-bf-price') && window.SanoBfConcept && window.SanoBfConcept.enabled);});
  if (!prices.length) return;

  function formatCents(cents) {
    return new Intl.NumberFormat('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function animatePrice(price) {
    if (price.dataset.priceAnimated === 'true') return;

    var current = price.querySelector('.sano-home-product-card__price-current');
    var sale = Number(price.dataset.salePriceCents);
    var compare = Number(price.dataset.comparePriceCents);
    if (price.hasAttribute('data-sano-bf-price') && !(price.dataset.referenceVerified === 'true' && sale === 1999 && compare === 4299)) return;
    if (!current || !Number.isFinite(sale) || !Number.isFinite(compare) || compare <= sale) return;

    price.dataset.priceAnimated = 'true';
    price.classList.add('is-price-animating');
    current.textContent = formatCents(compare);

    var startedAt = null;
    var duration = price.hasAttribute('data-sano-bf-price') ? 1600 : 620;
    function tick(timestamp) {
      if (startedAt === null) startedAt = timestamp;
      var progress = Math.min((timestamp - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      current.textContent = formatCents(Math.round(compare + ((sale - compare) * eased)));

      if (progress < 1) {
        window.requestAnimationFrame(tick);
        return;
      }

      current.textContent = formatCents(sale);
      price.classList.remove('is-price-animating');
      price.classList.add('is-price-animated');
    }

    window.requestAnimationFrame(tick);
  }

  var priceObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      animatePrice(entry.target);
      priceObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.35 });

  prices.forEach(function (price) { priceObserver.observe(price); });
}());

(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-sano-faq-motion]');
  if (!roots.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  roots.forEach(function (root) {
    root.classList.add('is-faq-enhanced');

    root.querySelectorAll('.sano-faq__item').forEach(function (item) {
      var summary = item.querySelector('.sano-faq__summary');
      var closeTimer;
      if (!summary) return;

      if (item.open) item.classList.add('is-expanded');

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        window.clearTimeout(closeTimer);

        if (item.open && item.classList.contains('is-expanded')) {
          item.classList.remove('is-expanded');

          if (reducedMotion.matches) {
            item.open = false;
            return;
          }

          closeTimer = window.setTimeout(function () {
            if (!item.classList.contains('is-expanded')) item.open = false;
          }, 220);
          return;
        }

        item.open = true;
        window.setTimeout(function () {
          item.classList.add('is-expanded');
        }, 0);
      });
    });
  });
}());
